import { render, staticRenderFns } from "./MessageLogin.vue?vue&type=template&id=6ca2648b&"
import script from "./MessageLogin.vue?vue&type=script&lang=js&"
export * from "./MessageLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports